module.exports = __webpack_public_path__ + "img/homepage2_03-auditoria-en-seguros.1eb7132a.jpg";